export default "__VITE_ASSET__Cs3mO6t3__"